import React from 'react';
import { useTranslation } from 'react-i18next';

const Intl = ({ children }: any) => {
	const { t } = useTranslation();
	return <>{t(children)}</>;
};

export default Intl;
